import { render, staticRenderFns } from "./growerstockdetails2.vue?vue&type=template&id=20d6a1d0&scoped=true"
import script from "./growerstockdetails2.vue?vue&type=script&lang=js"
export * from "./growerstockdetails2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d6a1d0",
  null
  
)

export default component.exports